// extracted by mini-css-extract-plugin
module.exports = {"Actions":"ReflectionToolBar_Actions__2rE4w","Disable":"ReflectionToolBar_Disable__24-IQ"};